module.exports = __webpack_public_path__ + "static/media/paperless-icon.c895c329.svg";